import Vue from 'vue';

// กล่องทักทายมุมขวาบน: แสดงครั้งเดียวหลัง login แล้วหายเอง
const FLAG = 'dmeeting-greet-pending';

export const greetingToast = Vue.observable({ visible: false, title: '', message: '' });

// เรียกตอน login สำเร็จ: ให้หน้าแรกแสดงคำทักทายหนึ่งครั้ง
export function queueGreeting() {
  try {
    sessionStorage.setItem(FLAG, '1');
  } catch (e) {
    // ใช้ sessionStorage ไม่ได้ก็ข้ามการทักทาย
  }
}

// คืน true ครั้งเดียวหลัง queueGreeting (แล้วล้าง flag)
export function takeQueuedGreeting() {
  try {
    const pending = sessionStorage.getItem(FLAG) === '1';
    sessionStorage.removeItem(FLAG);
    return pending;
  } catch (e) {
    return false;
  }
}

export function showGreeting(title, message) {
  greetingToast.title = title;
  greetingToast.message = message;
  greetingToast.visible = true;
}

export function hideGreeting() {
  greetingToast.visible = false;
}
